import './CollectionTile.scss'

import { HDSIcon } from '@here/hds-react-components'
import {
  CollectionCategory,
  getCollectionCategoryUrlPath,
} from 'components/Collections/util/collection-category'
import React, { CSSProperties } from 'react'

interface CollectionTileProps {
  id: string
  name: string
  count: number
  category?: CollectionCategory
  onClick?: (id: string) => void
}

export default function CollectionTile({
  id,
  name,
  count,
  category,
  onClick,
}: CollectionTileProps): JSX.Element {
  const trimmedName = name.replace(/(\w{13})(?=\w)/g, '$1 ')

  return (
    <div
      className="CollectionTile"
      style={
        {
          backgroundImage: `url("${getCollectionCategoryUrlPath(category)}")`,
        } as CSSProperties
      }
      onClick={() => onClick !== undefined && onClick(id)}
    >
      <div className="CollectionTile__count">
        <HDSIcon
          name="map-marker"
          category="map-view"
          size="16px"
          style={{ '--hds-icon-color': 'var(--hds-background-secondary)' } as CSSProperties}
        />
        <span>{count}</span>
      </div>
      <div className="CollectionTile__name">
        <span>{trimmedName}</span>
      </div>
    </div>
  )
}
